import { FAQS_FOR_GENERATOR } from "services/pricing/faqs-service";

export default {
  title: "pricingPage.faq",
  questions: FAQS_FOR_GENERATOR
};
